<template>
  <div>
    <div
        v-if="showLoader"
        class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
    >
      <div
          class="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-yellow-500"
      ></div>
    </div>
    <div v-else class="relative overflow-x-auto shadow-md sm:rounded-sm mt-5">
      <table class="w-full text-left rtl:text-right text-gray-700">
        <thead>
          <tr class="bg-gray-100">
            <th scope="col" class="px-6 py-4">
              <div class="flex items-center">#</div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">Visit Code</div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">Patient Name</div>
            </th>
             <th scope="col" class="px-6">
               <div class="flex items-center">Insurance Provider</div>
             </th>
             <th scope="col" class="px-6">
               <div class="flex items-center">Claim Type</div>
             </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">Claimed Amount</div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">Claim Status</div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">Claim Date</div>
            </th>
            <th scope="col" class="px-6">
              <div class="flex items-center">Action</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(claim, index) in insuranceClaims"
            :key="index"
            class="border-b"
          >
            <td class="px-6 py-2">{{ index + 1 }}</td>
            <td class="px-6 py-2">{{ claim.visit?.VisitCode }}</td>
            <td class="px-6 py-2">{{ claim.patient?.FullName }}</td>
             <td class="px-6 py-2">
               <span
                 :class="claim.insurance_provider === 'SHA'
                   ? 'bg-orange-100 text-orange-800'
                   : 'bg-blue-100 text-blue-800'"
                 class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
               >
                 {{ claim.insurance_provider || 'M-TIBA' }}
               </span>
             </td>
             <td class="px-6 py-2">{{ formatLabel(claim.claim_type) }}</td>
            <td class="px-6 py-2">{{ formatCurrency(claim.claimed_amount) }}</td>
            <td class="px-6 py-2">{{ formatLabel(claim.claim_status) }}</td>
            <td class="px-6 py-2">{{ formatDate(claim.claimed_at) }}</td>
            <td class="px-6 py-2">
              <button
                @click="handleViewClaim(claim.id)"
                class="bg-custom-yellow text-white px-4 py-1 rounded"
              >
                View
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <PaginationComponent
        v-model:currentPage="currentPage"
        v-model:itemsPerPage="itemsPerPage"
        :totalPages="totalPages"
        :totalItems="totalItems"
        @update:currentPage="goToPage"
        @update:changePageSize="changePageSize"
    />

    <InsuranceClaimPreviewModal
      :show="showClaimModal"
      :claim="selectedClaim"
      @close="closeClaimModal"
      @claim-updated="handleClaimUpdated"
    />
  </div>
</template>
<script>
import PaginationComponent from "@/components/shared/pagination.vue";
import InsuranceClaimPreviewModal from "@/views/modals/InsuranceClaimPreviewModal.vue";
import apiClient from "@/services/api";

export default {
  name: "CashierInsuranceClaims",
  components: {
    PaginationComponent,
    InsuranceClaimPreviewModal,
  },
  mounted() {
    this.fetchInsuranceClaims();
  },
  props: {
    searchQuery: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showClaimModal: false,
      selectedClaim: null,
      showLoader: false,
      currentPage: 1,
      itemsPerPage: 10,
      pageSizes: [25, 50, 100],
      insuranceClaims: [],
      totalItems: 0,
      totalPages: 0,
    };
  },
  methods: {
    goToPage(pageNumber) {
      this.currentPage = pageNumber;
      this.fetchInsuranceClaims();
    },
    changePageSize(pageSize) {
      this.itemsPerPage = pageSize;
      this.fetchInsuranceClaims();
    },
    async fetchInsuranceClaims() {
      try {
        this.showLoader = true;
        const response = await apiClient.getInsuranceClaims({
          page: this.currentPage,
          per_page: this.itemsPerPage,
        });
        if (response.success) {
          this.showLoader = false;
          this.insuranceClaims = response.data;
          this.totalItems = response.meta.total_items;
          this.totalPages = response.meta.total_pages;
          this.itemsPerPage = response.meta.per_page;
        }
      } catch (error) {
        this.showLoader = false;
        this.$toast.error("Failed to fetch insurance claims");
        console.log(error);
      }
    },
    handleViewClaim(claimId) {
      const selectedClaim = this.insuranceClaims.find((claim) => claim.id === claimId);
      if (selectedClaim) {
        this.selectedClaim = selectedClaim;
        this.showClaimModal = true;
      }
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "KES",
      }).format(value);
    },
    closeClaimModal() {
      this.showClaimModal = false;
      this.selectedClaim = null;
    },
    formatDate(dateString) {
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };
      const date = new Date(dateString);
      return date.toLocaleString("en-US", options);
    },
    formatLabel(str) {
      if (!str) return '';
      return str.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    },
    handleClaimUpdated() {
      // Refresh the claims list when a claim is updated
      this.fetchInsuranceClaims();
    },
  },
};
</script>

<style lang="css" scoped></style>